import React from "react";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";

const TwoColumnRightLayout = ({ rendering }) => (
  <section className='twocol'>
    <div className='twocol-small'>
      <Placeholder name='jss-two-col-small' rendering={rendering} />
      <div className='twocol-small-left-align'>
        <Placeholder name='jss-col-left-align' rendering={rendering} />
      </div>
    </div>
    <div className='twocol-large'>
      <Placeholder name='jss-two-col-large' rendering={rendering} />
    </div>
  </section>
);

export default TwoColumnRightLayout;
